import { createToaster } from '@skeletonlabs/skeleton-svelte';

export const toaster = createToaster({
	placement: 'top',
	overlap: false
});
